import React, { useEffect, useState } from 'react'
import UserEngagement from '../UserEngagement/UserEngagement'
import SuccessStory from '../SuccessStory'
import { useSelector } from 'react-redux';
import PersonaliseCard from './PersonaliseCard';
import GetCertifiedCard from './GetCertifiedCard';
import Faq from '../Faq';
import OtherSkills from '../OtherSkills';
import RequestCV from '../RequestCV';
import RequestInterview from '../RequestInterview';
import RecruiterButton from './RecruiterButton';
import RolesQualified from '../RolesQualified';
import RadarChart from '../RadarChart';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';
import { v4 as uuidv4 } from 'uuid';

const RecruiterVariant = ({openLinkedInLogin ,requestCvRef , requestInterviewRef , handlerCertified,handlerPersonalise , targetRef , loading}) => {
   const userDetails = useSelector(
      (store) => store?.certificateVerification?.userInfo
    );
    const certificateData = useSelector((store)=>store?.certificateVerification?.certificateData);
    const [isRequestCv , setIsRequestCv] = useState(false);
    const [isRequestInterview , setIsRequestInterview] = useState(false);
    const islocked = useSelector((store)=>store?.certificateVerification?.is_locked);

    useEffect(() => {
      // First run: remember initial state
      if(!loading){
      
        Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_RECRUITER_PAGE_LOADED);
       
      }
    }, [loading]);
    
   return (
    <div className='w-full mt-6'>
      <UserEngagement openLinkedInLogin={openLinkedInLogin}/>
      
      <div className='mt-2' ref={targetRef}>
        <RecruiterButton requestCvRef={requestCvRef}  requestInterviewRef={requestInterviewRef} handlerPersonalise={handlerPersonalise} setIsRequestCv={setIsRequestCv} setIsRequestInterview={setIsRequestInterview}/>

      </div>
      <div className="mt-4">
        <div className="font-medium text-[16px] md:text-[20px] text-white text-center">Roles {certificateData?.name?.split(" ")[0]} <span className="font-bold text-[#00C1FF]"> Qualifies </span> For:</div>
        <div className="mt-3">
          <RolesQualified/>
        </div>

      </div>
       <div className="mt-2" ref={requestCvRef}>
        <RequestCV isActive={isRequestCv} setIsActive={setIsRequestCv} />
      </div>
       <div className="mt-2" ref={requestInterviewRef}>
        <RequestInterview isActive={isRequestInterview} setIsActive={setIsRequestInterview}/>
      </div>
        { certificateData?.certificate_type!=="personalized" && <div className="mt-8">
        <div className="text-center text-[24px] md:text-[28px] font-medium leading-[130%] text-white px-4">
          Basis Quiz Analysis, {certificateData?.name?.split(" ")?.[0]}'s
          <span className="text-[28px] md:text-[32px] font-bold text-[#00C1FF]">
            {" "}
            Top Strengths:{" "}
          </span>
        </div>
        <div className="mt-4">
          <RadarChart/>
        </div>
      </div>}
       <div
              className="mt-8 -ml-4 flex w-[calc(100%+30px)] flex-col items-center justify-start bg-[#4285F4]/80  py-6 px-4"
              style={{
                backgroundImage: `linear-gradient(to bottom, rgba(13, 36, 54, 1) 0%, rgba(13, 36, 54, 0.5) 100%)`,
              }}
            >
              <div className="text-center text-[24px] md:text-[28px] font-medium leading-[130%] text-white">
                Join {certificateData?.name?.split(" ")?.[0]}{" "} &
                <span className="text-[28px] md:text-[32px] font-bold text-[#00C1FF]">
                  {" "}
                  3x Your Career Growth{" "}
                </span>{" "}
                With LearnTube
              </div>
              <div className="mt-4 w-full">
                <PersonaliseCard handlerPersonalise={handlerPersonalise}/>
              </div>
              <div className="mt-4 w-full">
                <GetCertifiedCard handlerCertified={handlerCertified}/>
              </div>
            </div>
            <div className="mt-8">
              <SuccessStory />
            </div>
            <div className='mt-8'>
              <OtherSkills handlerCertified={handlerCertified}/>
            </div>
            {/* <div className="mt-8">
              <div className="mb-4 text-center text-[24px] md:text-[28px] font-medium text-white">
                Frequently{" "}
                <span className="text-[28px] md:text-[32px] font-bold text-[#00C1FF]"> Asked </span>{" "}
                Questions
              </div>
              <Faq />
            </div> */}
    </div>
  )
}

export default RecruiterVariant
